import { useNavigate } from '@tanstack/react-router'
import { Code2, X } from 'lucide-react'
import { useToasts } from '@/state/toasts'
import { IconButton } from './ui'

/**
 * Toasts over the top of the app, under the status bar: a hairline card, no
 * shadow. The body opens what it names; the × only puts it away.
 */
export const Toasts = () => {
  const toasts = useToasts((s) => s.toasts)
  const dismiss = useToasts((s) => s.dismiss)
  const navigate = useNavigate()
  if (!toasts.length) return null
  return (
    <div
      className="fixed inset-x-3 z-50 flex flex-col items-center gap-2 pointer-events-none top-[calc(env(safe-area-inset-top)+0.5rem)]"
      role="status"
      aria-live="polite"
    >
      {toasts.map((t) => (
        <div
          key={t.id}
          className="toast-in pointer-events-auto w-full max-w-sm flex items-center gap-1 border border-line bg-panel pl-3 pr-1"
          style={{ borderRadius: 'var(--radius-card)' }}
          data-testid="toast"
        >
          <button
            type="button"
            disabled={!t.to}
            onClick={() => {
              dismiss(t.id)
              if (t.to) void navigate({ to: t.to })
            }}
            className="flex flex-1 min-w-0 items-center gap-2 min-h-11 text-left text-sm"
          >
            <Code2 size={15} className="shrink-0 text-accent-text" aria-hidden />
            <span className="truncate">{t.text}</span>
          </button>
          <IconButton label="Dismiss" onClick={() => dismiss(t.id)}>
            <X size={15} aria-hidden />
          </IconButton>
        </div>
      ))}
    </div>
  )
}
